import styled from 'styled-components';

const Styled = styled.div`
    /* refer to defined props here */
    --isFileManager: ${props => props.isFileManager};

    /* height: ${props => (props.isFileManager ? '500px' : '100%')} */
    height: 100%;

    .file-list-icon-list {
        width: 100%;
        height: ${props => (props.isFileManager ? '100%' : 'calc(100% - 30px)')};
        overflow: auto;

        @media only screen and (width <= 575px) {
            height: ${props => (props.isFileManager ? '100%' : 'calc(100% - 50px)')};
        }
    }


    .infinite-scroll {
        /* deduct height of DOMs that are not the infinite scroll */
        height: ${props => props.isFileManager && 'calc(100vh - 418px)'};
        min-height: 100px;
        
        @media only screen and (width <= 767px)  {
            height: ${props => props.isFileManager && 'calc(100vh - 426px)'};
        }

        @media only screen and (width >= 535px) and (width <= 580px)  {
            height: ${props => props.isFileManager && 'calc(100vh - 356px)'};
        }

        @media only screen and (width >= 475px) and (width <= 535px)  {
            height: ${props => props.isFileManager && 'calc(100vh - 378px)'};
        }
        
    }

    .time-group {
        .label {
            padding-top: 8px;
            padding-bottom: 8px;
            font-size: 11px;
            font-weight: bold;
            color: #888;
            text-transform: uppercase;
        }
    }

    .ant-spin-container {
        .ant-row {
            margin-right: 0 !important;
            margin-left: 0 !important;
        }
    }

    .top-button {
        margin-right: 8px;
        
        &:last-child {
            margin-right: 0;
        }
    }

    .group-heading-row {
        display: flex;
        justify-content: space-between;
        margin: 8px 0 4px;
        font-size: 11px;
        font-weight: 500;
        line-height: 1.45454545;
        color: #8993a4;
        text-transform: uppercase
    }

    .col__file-icon {
        display: grid; 
        place-items: center;
        margin: auto;

        .file-icon, .preview-icon {
            justify-content: center;
            width: 100%;
            height: auto;
            padding-right: 15px;
            font-size: 30px;
            text-align: center;
            transition: opacity 0.3s;
        }

        .preview-icon {
            position: absolute;
            font-size: 20px;
            opacity: 0;
        }

        &:hover {
            .preview-icon {
                opacity: 1;
                transition: opacity 0.3s;
            }

            .file-icon {
                opacity: 0;
                transition: opacity 0.3s;
            }
        }
    }

   
    
    .selected-file-card {
        background-color: #e6f6ff;

        .ant-card-hoverable:hover {
            border: 10px solid #e6f6ff;
        }
    }

    .pagination-div {
        display: flex;
        justify-content: flex-end;
        padding-top: 8px;
    }
    
     /* #file-list-icon-list {

         .ant-tag {
             line-height: 36px;
             margin-bottom: 5px;
             border: none;
             border-radius: 6px;
             opacity: 100%;
         }
     } */

    /* Override styles for FileCardTransaction */
    &.transaction-panel-attachment {
        height: unset;

        .col__file-icon {
            .file-icon, .preview-icon {
                padding-right: 12px;
                font-size: 26px;
            }

            .preview-icon {
                font-size: 20px;
            }
        }

        .ant-card-actions {
            li {
                margin: 10px;
            }
        }
    }
`;

const StyledCardWrapper = styled.div`

    .card-skeleton--right {
        .ant-skeleton.ant-skeleton-element {
            width: 100%
        }
    }

    .fade-in {
        animation: fadeInAnimation 0.3s cubic-bezier(.48,.90,.48,.90);
    }
    
    @keyframes fadeInAnimation {
        from { 
            background-color: #d9f7be; 
            opacity: 0; 
            transform: translateX(-60px);
        }

        to { 
            background-color: none;
             opacity: 1; 
            transform: translateX(0);
        }
    }

    .fade-out {
        animation: fadeOutAnimation 0.3s cubic-bezier(.48,.90,.48,.90);
    }
      
    @keyframes fadeOutAnimation {
        from {
            background-color: #fff1f0; 
            opacity: 1; 
            transform: translateX(0);
        }

        to { 
            background-color: none; 
            opacity: 0; 
            transform: translateX(-60px);
        }
    }   
    
    .col-card-detail {
        .h5-title {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .ant-tooltip-open {
                font-size: 100%;
            }
        }

        .row-file-size {
            display: flex;

            /* justify-content: space-between; */
            align-items: center;

            .row-file-size__col {
                font-size: 80%;
            }
        }

        .col-uploaded {
            font-size: 0.72rem;
            color: grey;
        }

        .col-lock-icon {
            font-size: 0.83em;
            color: red;

            .ant-tooltip-open {
                font-size: 100%;
            }
        }
    }
  
`;

export {Styled, StyledCardWrapper};
